export enum DataPortalAdministrationTabs {
  CENSUS = 'census',
  AGE_GROUPS = 'age-groups',
  BENEFICIARIES = 'beneficiaries',
  POLICY_DOCUMENTS = 'policy-documents'
}
